import { createSlice } from "@reduxjs/toolkit";
import { noticReducer } from "../extraReducers/noticReducer";

// 定义初始化数据
const initialState = {
  noticList: {} as any,
  uploadNoticPictureConfig: {} as any,
};

const noticSlice = createSlice({
  name: "noticSlice",
  initialState,
  reducers: {},
  extraReducers: noticReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default noticSlice.reducer;
